import * as React from 'react';
import { ICryoShipmentPending } from './cryo-shipment-pending';

interface IProps {
    data: ICryoShipmentPending,
    onTrackingNumberChange: (xmTrackingId: number, trackingNumber: string) => void
}

class NkrLabRow extends React.Component<IProps, {}> {
    handleTrackingNumberChange = (e: React.FormEvent<HTMLInputElement>) => {
        this.props.onTrackingNumberChange(this.props.data.xmTrackingId, e.currentTarget.value);
    }

    render = () => {
        const item = this.props.data;

        return (
            <tr>
                <td>{item.xmTrackingId}</td>
                <td>{item.donorCenter}</td>
                <td>{item.donorAlias}</td>
                <td>{item.recipientCenter}</td>
                <td>{item.recipientAlias}</td>
                <td>{item.orderDate}</td>
                <td><input className='form-control' type='text' value={item.trackingNumber} onChange={this.handleTrackingNumberChange} /></td>
            </tr>
        );
    }
}

export default NkrLabRow;